export interface IndustryData {
  slug: string;
  labelDe: string;
  labelEn: string;
  minCPC: number; // 25th percentile €
  medianCPC: number; // median €
  maxCPC: number; // 75th percentile €
  notesDe: string;
  notesEn: string;
}

export const INDUSTRY_DATABASE: Record<string, IndustryData> = {
  "ecommerce-fashion": {
    slug: "ecommerce-fashion",
    labelDe: "E-Commerce — Mode & Lifestyle",
    labelEn: "E-commerce — Fashion & lifestyle",
    minCPC: 0.6,
    medianCPC: 1.2,
    maxCPC: 2.5,
    notesDe:
      "Hoher Wettbewerb durch internationale Player. CPC-Bandbreite je nach Markenpositionierung substantiell.",
    notesEn:
      "High competition from international players. CPC range varies substantially by brand positioning.",
  },
  "ecommerce-food": {
    slug: "ecommerce-food",
    labelDe: "E-Commerce — Lebensmittel & Getränke",
    labelEn: "E-commerce — Food & beverages",
    minCPC: 0.4,
    medianCPC: 0.9,
    maxCPC: 1.8,
    notesDe:
      "Niedrige CPCs, aber knappe Margen. Konversions-Optimierung und AOV-Steigerung kritisch.",
    notesEn:
      "Low CPCs but tight margins. Conversion optimization and AOV increase critical.",
  },
  "wohnaccessoires-heimtextilien": {
    slug: "wohnaccessoires-heimtextilien",
    labelDe: "E-Commerce — Wohnaccessoires & Heimtextilien",
    labelEn: "E-commerce — Home accessories & textiles",
    minCPC: 0.5,
    medianCPC: 0.95,
    maxCPC: 1.8,
    notesDe:
      "Mittlerer AOV-Bereich (50-300€) zwischen Lebensmitteln und Möbeln. Visuelle Produkt-Präsentation und Cross-Selling-Bundles methodisch substantiell.",
    notesEn:
      "Mid-range AOV (€50-300) between groceries and furniture. Visual product presentation and cross-selling bundles methodically substantial.",
  },
  "ecommerce-furniture": {
    slug: "ecommerce-furniture",
    labelDe: "E-Commerce — Möbel & Wohnen",
    labelEn: "E-commerce — Furniture & home",
    minCPC: 1.2,
    medianCPC: 2.8,
    maxCPC: 5.0,
    notesDe:
      "Hochpreisige Produkte, längerer Recherche-Zyklus. CPC kompensiert über hohen AOV.",
    notesEn:
      "High-priced products, longer research cycle. CPC compensated by high AOV.",
  },
  "b2b-saas": {
    slug: "b2b-saas",
    labelDe: "B2B SaaS / Software",
    labelEn: "B2B SaaS / Software",
    minCPC: 4.0,
    medianCPC: 8.5,
    maxCPC: 18.0,
    notesDe:
      "Hohe CPCs, aber hoher Customer Lifetime Value rechtfertigt das wirtschaftlich.",
    notesEn:
      "High CPCs, but high Customer Lifetime Value justifies this economically.",
  },
  "b2b-industry": {
    slug: "b2b-industry",
    labelDe: "B2B Industrie & Maschinenbau",
    labelEn: "B2B Industry & machinery",
    minCPC: 2.5,
    medianCPC: 5.5,
    maxCPC: 12.0,
    notesDe: "Lange Sales-Zyklen, Lead-Qualität wichtiger als Quantität.",
    notesEn: "Long sales cycles, lead quality more important than quantity.",
  },
  handwerk: {
    slug: "handwerk",
    labelDe: "Handwerk (Bau, Installation, Sanierung)",
    labelEn: "Crafts (Construction, installation, renovation)",
    minCPC: 3.0,
    medianCPC: 6.5,
    maxCPC: 12.0,
    notesDe:
      "Lokale Suche dominiert. Geo-Targeting und Anruf-Tracking essenziell.",
    notesEn:
      "Local search dominates. Geo-targeting and call tracking essential.",
  },
  "pflege-gesundheit": {
    slug: "pflege-gesundheit",
    labelDe: "Pflege & Gesundheitsdienstleistungen",
    labelEn: "Care & healthcare services",
    minCPC: 2.8,
    medianCPC: 5.8,
    maxCPC: 11.0,
    notesDe:
      "Recruiting-Schwerpunkt mit hoher Bedarfslage. Meta Ads oft effizienter als Google Ads.",
    notesEn:
      "Recruiting focus with high demand. Meta Ads often more efficient than Google Ads.",
  },
  rechtsberatung: {
    slug: "rechtsberatung",
    labelDe: "Rechtsberatung & Anwaltskanzleien",
    labelEn: "Legal advice & law firms",
    minCPC: 6.0,
    medianCPC: 12.5,
    maxCPC: 25.0,
    notesDe:
      "Höchste CPC-Range im DACH-Markt. Lange Conversion-Zyklen, hoher Mandate-Wert.",
    notesEn:
      "Highest CPC range in DACH market. Long conversion cycles, high mandate value.",
  },
  "steuer-unternehmensberatung": {
    slug: "steuer-unternehmensberatung",
    labelDe: "Steuer- & Unternehmensberatung",
    labelEn: "Tax & business consulting",
    minCPC: 4.5,
    medianCPC: 9.0,
    maxCPC: 18.0,
    notesDe:
      "B2B-Mandate mit hohem Wert. Lead-Magnete (z.B. Erstgespräch) Conversion-kritisch.",
    notesEn:
      "B2B mandates with high value. Lead magnets (e.g. initial consultation) conversion-critical.",
  },
  "bildung-weiterbildung": {
    slug: "bildung-weiterbildung",
    labelDe: "Bildung & Weiterbildung",
    labelEn: "Education & professional development",
    minCPC: 3.5,
    medianCPC: 7.0,
    maxCPC: 14.0,
    notesDe:
      "Mobile-dominiert. Klare Funnel-Architektur mit Brochure-Download als Erst-Conversion.",
    notesEn:
      "Mobile-dominated. Clear funnel architecture with brochure download as first conversion.",
  },
  "logistik-transport": {
    slug: "logistik-transport",
    labelDe: "Logistik & Transport",
    labelEn: "Logistics & transport",
    minCPC: 1.8,
    medianCPC: 3.5,
    maxCPC: 7.5,
    notesDe:
      "B2B-Schwerpunkt. Recruiting bei Fahrer-Mangel zusätzlicher Hebel.",
    notesEn: "B2B focus. Recruiting for driver shortage additional lever.",
  },
  "gastronomie-hotellerie": {
    slug: "gastronomie-hotellerie",
    labelDe: "Gastronomie & Hotellerie",
    labelEn: "Restaurants & hospitality",
    minCPC: 1.5,
    medianCPC: 3.0,
    maxCPC: 6.0,
    notesDe:
      "Lokale Suche dominiert. Google Maps / Local Pack wichtiger als klassische Search Ads.",
    notesEn:
      "Local search dominates. Google Maps / Local Pack more important than classic search ads.",
  },
  recruiting: {
    slug: "recruiting",
    labelDe: "Recruiting & Personalvermittlung",
    labelEn: "Recruiting & staffing",
    minCPC: 2.0,
    medianCPC: 4.5,
    maxCPC: 9.0,
    notesDe:
      "Meta Ads oft Primär-Kanal, nicht Google Ads. CPC-Bandbreite je nach Berufsfeld substantiell.",
    notesEn:
      "Meta Ads often primary channel, not Google Ads. CPC range varies substantially by job field.",
  },
  automotive: {
    slug: "automotive",
    labelDe: "Automotive (Werkstätten, Händler)",
    labelEn: "Automotive (Workshops, dealers)",
    minCPC: 2.8,
    medianCPC: 5.5,
    maxCPC: 10.0,
    notesDe:
      "Hohe Conversion-Raten in Werkstatt-Segment. Anruf-Tracking essenziell.",
    notesEn:
      "High conversion rates in workshop segment. Call tracking essential.",
  },
  "versicherungen-finanz": {
    slug: "versicherungen-finanz",
    labelDe: "Versicherungen & Finanzdienstleistungen",
    labelEn: "Insurance & financial services",
    minCPC: 5.0,
    medianCPC: 10.5,
    maxCPC: 22.0,
    notesDe:
      "Hochregulierter Markt. Lange Conversion-Zyklen mit mehreren Touchpoints.",
    notesEn:
      "Highly regulated market. Long conversion cycles with multiple touchpoints.",
  },
};

export const INDUSTRY_LIST: IndustryData[] = Object.values(INDUSTRY_DATABASE);
